import classNames from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useTimer } from 'react-timer-hook'

import { useModalStore } from '@features/modal'

import { ModalBonus } from '@widgets/modal-bonus'

import { copyText, formatCardNumber, formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'




interface ICardProps {
  className?: string;
}

interface ICardProps {
  className?: string;
  cardNumber: string | null | undefined;
  balance: number | null | undefined;
  pendingBonusesAmount: number | undefined;
  bonusExpireAmount: number | null | undefined;
  bonusExpireAt: string | null;
}

export const Card: React.FC<ICardProps> = ({
  className,
  cardNumber,
  balance,
  pendingBonusesAmount,
  bonusExpireAmount,
  bonusExpireAt,
}) => {
  const { openModal } = useModalStore()
  const { t: tp } = useTranslation('personal')
  const { t: tn } = useTranslation('personal')
  const [ isCopied, setIsCopied ] = useState(false)

  const { restart } = useTimer({
    expiryTimestamp: new Date(), 
    autoStart: false,
    onExpire: () => setIsCopied(false),
  })

  const handleCopy = () => {
    setIsCopied(true)

    copyText(cardNumber || '')

    const time = new Date()
    // Устанавливаем новый таймер на 2 секунды
    time.setSeconds(time.getSeconds() + 2)
    restart(time)
  }

  return (
    <div className={classNames(styles.card, className)}>
      <div>
        <span className={styles.root__text}>{tp('bonus.available')}:</span>
        <div className={styles.card__bonus}>
          <ReactSVG src="/icons/bonus.svg" />
          <span className={styles.card__count}>
            {formatPrice(balance || 0, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
              style: 'decimal',
            })}{' '}
            {tp('bonus.bonuses')}
          </span>
          {/* <span className={styles.card__about}>~200 ₸</span> */}{' '}
          {/* //временно скрыто */}
          {bonusExpireAmount && bonusExpireAt && (
            <p className={styles.card__nearestExpiringBonus}>
              <span>
                {formatPrice(bonusExpireAmount, { style: 'decimal', maximumFractionDigits: 0 })} {tp('bonusHistory.expire')} {bonusExpireAt}
              </span>{' '}
              <ReactSVG src="/icons/flame.svg" wrapper="span" />
            </p>
          )}
        </div>

        <span className={styles.root__text}>{tp('bonus.expired')}</span>
        <div className={styles.card__wait}>
          <ReactSVG src="/icons/wait.svg" />
          <span>
            {formatPrice(pendingBonusesAmount || 0, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
              style: 'decimal',
            })}{' '}
            {tp('bonus.bonuses')}
          </span>
        </div>
      </div>
      <div className={styles.card__right}>
        <ReactSVG
          onClick={() => {
            openModal('bonus', <ModalBonus card={cardNumber} />, {
              title: tp('bonus.modal'),
            })
          }}
          className={styles.card__zoom}
          src="/icons/zoom.svg"
        />
        {cardNumber && (
          <div className={styles.card__number}>
            <span>№ {formatCardNumber(+cardNumber)}</span>
            <ReactSVG
              onClick={handleCopy}
              className={styles.card__copy}
              src="/icons/copy.svg"
            />
            {isCopied && (
              <p className={styles.card__copied}>{tn('qrModal.copied')}</p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}